import { createSafeContext } from '@lib/utils/createSafeContext';

export interface User {
  id: string;
  email: string | null;
  name: string | null;
  avatarUrl: string | null;
}

export interface AuthContextType {
  isAuthenticated: boolean;
  isLoading: boolean;
  isInitialized: boolean;
  user: User | null;
  login: () => void;
  logout: () => Promise<void>;
  register: () => void;
  getAccessToken: () => Promise<string | undefined>;
}

export const [AuthProvider, useAuthContext] = createSafeContext<AuthContextType>(
  'useAuthContext must be used within AuthProvider'
);
